import Reveal from "./Reveal";
import { MapPin, Timer } from "lucide-react";

const regions = [
  "Île-de-France",
  "Auvergne-Rhône-Alpes",
  "Nouvelle-Aquitaine",
  "Occitanie",
  "Hauts-de-France",
  "PACA",
  "Grand Est",
];

export default function Scarcity() {
  return (
    <section id="vision" data-testid="scarcity-section" className="relative py-28 md:py-36">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-emerald-400 mb-6">
            02 — Exclusivité territoriale
          </p>
          <h2 className="font-display font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl">
            Sept territoires.
            <br />
            <span className="text-stroke-emerald">Sept dirigeants.</span>
            <br />
            Rien de plus.
          </h2>
          <p className="mt-6 text-base md:text-lg text-slate-400 leading-relaxed max-w-lg">
            Chaque agence Alternativ dispose d&rsquo;une exclusivité géographique verrouillée.
            Quand les sept territoires seront attribués, le recrutement 2027 fermera —
            définitivement.
          </p>
          <div
            data-testid="scarcity-counter-badge"
            className="mt-8 inline-flex items-center gap-3 rounded-2xl border border-emerald-400/20 bg-emerald-400/5 px-5 py-4"
          >
            <Timer className="w-5 h-5 text-emerald-300" />
            <span className="font-jbmono text-sm text-emerald-300">
              Ouverture des candidatures imminente
            </span>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative rounded-[2rem] border border-emerald-400/15 bg-[#0E1713]/80 backdrop-blur-md p-8 md:p-10 overflow-hidden">
            <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-emerald-500/10 blur-[100px]" />
            <div className="flex items-end justify-between mb-8">
              <div>
                <p className="font-jbmono text-[11px] uppercase tracking-[0.3em] text-slate-500">Places 2027</p>
                <p className="font-display font-extrabold text-7xl md:text-8xl text-emerald-400 leading-none mt-2">
                  7
                </p>
              </div>
            </div>

            <div className="flex gap-2.5 mb-8">
              {regions.map((r) => (
                <span key={r} className="flex-1 h-2 rounded-full bg-emerald-400/25 relative overflow-hidden">
                  <span className="absolute inset-0 bg-emerald-400/60 animate-pulse" style={{ animationDelay: `${regions.indexOf(r) * 0.25}s` }} />
                </span>
              ))}
            </div>

            <ul className="grid sm:grid-cols-2 gap-3">
              {regions.map((r, i) => (
                <li
                  key={r}
                  data-testid={`scarcity-region-${i}`}
                  className="group flex items-center gap-3 rounded-xl border border-emerald-400/10 bg-[#070C0A]/60 px-4 py-3 transition-colors duration-300 hover:border-emerald-400/40"
                >
                  <span className="w-2 h-2 rounded-full bg-emerald-400 animate-beacon shrink-0" style={{ animationDelay: `${i * 0.3}s` }} />
                  <span className="text-sm text-slate-300 group-hover:text-emerald-200 transition-colors">{r}</span>
                  <MapPin className="w-3.5 h-3.5 ml-auto text-slate-600 group-hover:text-emerald-400 transition-colors" />
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
